import { diunaImperiumChapters } from './content';
export const diunaImperiumGlossary = diunaImperiumChapters.find((chapter) => chapter.title.toLocaleUpperCase('pl').includes('GLOSSARY'));
